<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-3">
      <b-form-row class="mb-4">
        <b-col class="form-group">
          <h3 class="common__search-title">Tutor</h3>
          <input
            v-model="conditions.tutor"
            type="text"
            class="form-control w-25"
          >
        </b-col>
      </b-form-row>
      <h3 class="common__search-title">Lesson Date</h3>
      <b-form-row class="mb-4">
        <b-col>
          <div>from</div>
          <DateInput v-model="conditions.lessonDateFrom" />
        </b-col>
        <b-col>
          <div>to</div>
          <DateInput v-model="conditions.lessonDateTo" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-4">
        <b-col>
          <h3 class="common__search-title">Level</h3>
          <LevelsInput v-model="conditions.levels"/>
        </b-col>
        <b-col>
          <h3 class="common__search-title">Task Type</h3>
          <TaskTypesInput v-model="conditions.types"/>
        </b-col>
      </b-form-row>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang='ts'>
import Vue from 'vue'
import _ from 'lodash';
import LevelsInput from '@/components/parts/inputItem/LevelsInput.vue';
import TaskTypesInput from '@/components/parts/inputItem/TaskTypesInput.vue';
import DateInput from '@/components/parts/inputItem/DateInput.vue';
import { DeadlineConditions } from '@/store/deadlines/types'

// 検索の初期設定値
const initialConditions: DeadlineConditions = {
  tutor: null,
  deadlineInTimes: [],
  deadlineSends: [],
  deadlineFrom: null,
  deadlineTo: null,
  lessonDateFrom: null,
  lessonDateTo: null,
  levels: [],
  types: [],
}

export default Vue.extend({
  data() {
    return {
      conditions: _.cloneDeep(initialConditions),
    };
  },

  components: {
    LevelsInput,
    DateInput,
    TaskTypesInput,
  },

  methods: {
    search() {
      // 検索ボタン押した場合
      this.$emit('search', this.conditions)
    },
    reset() {
      // リセットボタン押した場合
      this.conditions = _.cloneDeep(initialConditions);
      this.search();
    },
  },
  created() {
    this.search();
  },
});

</script>

<style scoped>
</style>
